import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';
import { Observable } from 'rxjs';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {RequestsGridComponent} from '../../components/Requests/RequestsGrid.component';
import {UserMessageComponent} from '../../components/Controls/UserMessage.component';

@Component({
  selector: 'my-dashboard',
  templateUrl: './Dashboard.component.html'
})
export class DashboardComponent implements OnInit {

    @ViewChild(UIChart) uiChart: UIChart;
    @ViewChild(RequestsGridComponent) requestsGridComponent: RequestsGridComponent;
    @ViewChild(UserMessageComponent) userMessageComponent: UserMessageComponent;

    public noExistingRequests: boolean;
    userInfo: ent.UserInfo;
    requestTotalsByTypeAndStatus: ent.RequestTotalsByTypeAndStatus[] = [];

    requestTotalsData: any = {};
    options: any;


    constructor(private authenticationService: serv.AuthenticationService, private requestService: serv.RequestService, private router: Router) 
    {
        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        
        this.requestTotalsData.labels = [];
        this.requestTotalsData.datasets = [];
        this.options = {
            scales: {
                xAxes: [{ticks: {autoSkip: false}}]
            }
        }
        this.load();
    }

    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();

       
        
        

    }
    ngAfterViewInit(){
        this.requestsGridComponent.requestStatusIDsToSelectOnLoad = [enums.RequestStatusEnum.Open];

        this.requestsGridComponent.employeeIDsToSelectOnLoad = [this.userInfo.Employee.ID];
        

        this.requestsGridComponent.loadRequestStatuses().subscribe(x=> {
            this.requestsGridComponent.onSearchClick(null);
        });
        
        Observable.forkJoin([
            this.requestsGridComponent.loadEmployees(),
            this.requestsGridComponent.loadRequestStatuses(),
            this.requestsGridComponent.loadRequestTypes(),
            this.requestsGridComponent.loadSalesOffices()
          ]).subscribe(value => {
                this.requestsGridComponent.onSearchClick(null);
                this.requestsGridComponent.updateRequests.subscribe((x: boolean)=>this.onUpdateRequests(x));
          });

    }

    onRefreshClick(event: any){
        this.load();
        this.requestsGridComponent.onSearchClick(null);
        this.userMessageComponent.getUserMessage();
    }

    onUpdateRequests(x: boolean){
        setTimeout(()=>{    
            this.load();
            // console.info("onUpdateRequests");
            this.requestsGridComponent.onSearchClick(null);
            this.uiChart.refresh();
       },500);
        
    }

    load(){
        var filter: filters.RequestFilter = {EmployeeIDs: [this.userInfo.Employee.ID]};
        this.requestService.getRequestTotalsByTypeAndStatus(filter).subscribe(x=> this.onGetRequestTotalsByTypeAndStatusDone(x));
    }


    onGetRequestTotalsByTypeAndStatusDone(requestTotalsByTypeAndStatus: ent.RequestTotalsByTypeAndStatus[]): void {
        
        this.noExistingRequests = false;
        if (!requestTotalsByTypeAndStatus){
            this.noExistingRequests = true;
        }
        else if (requestTotalsByTypeAndStatus.length == 0)
        {
            this.noExistingRequests = true;
        }
        else{
            var myLabels: string[] = [];
            var myDatasets: ent.Dataset[] = [];
            for (var requestTotal of requestTotalsByTypeAndStatus)
            {
                if (myLabels.filter(x=>x==requestTotal.RequestType).length==0)
                {
                    myLabels.push(requestTotal.RequestType);
                }
                
                
                var ds: ent.Dataset;
                var existingDatasets = myDatasets.filter(x=>x.label == requestTotal.Status);
                if (existingDatasets.length == 0)
                {
                    ds = {backgroundColor: "FireBrick", borderColor:"black", label:requestTotal.Status, data:[]};
                    if (requestTotal.Status == "Open")
                    {
                        ds.backgroundColor = "DeepSkyBlue";
                        ds.borderColor = "black";
                    }
                    else if (requestTotal.Status == "Emailed")
                    {
                        ds.backgroundColor = "ForestGreen";
                        ds.borderColor = "black";
                    }
                    else if (requestTotal.Status == "Submitted")
                    {
                        ds.backgroundColor = "DarkOrange";
                        ds.borderColor = "black";
                    }
                    else if (requestTotal.Status == "Completed")
                    {
                        ds.backgroundColor = "DarkOrchid";
                        ds.borderColor = "black";
                    }
                    
                    myDatasets.push(ds);
                }
                else
                {
                    ds = existingDatasets[0];
                }
                ds.data.push(requestTotal.RequestCount);
            }
            this.requestTotalsData = {
                labels: myLabels,
                datasets: myDatasets
            }
        }
        
        
    }

}